import { render, staticRenderFns } from "./ProfileViewHeader.vue?vue&type=template&id=3f256fcb&scoped=true&"
import script from "./ProfileViewHeader.vue?vue&type=script&lang=js&"
export * from "./ProfileViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f256fcb",
  null
  
)

export default component.exports